var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512,86v340c-4.4,23-22,40.5-45.5,43H47.5c-24.8-1.7-42.7-19.1-47.5-43V86c4.8-23.9,22.7-41.3,47.5-43h419c21.8,1.7,42.9,21.2,45.5,43ZM47.7,83.2c-5,1.9-10.4,8.2-5.2,12.8,70.2,69.1,138.4,140.5,209.8,208.2l7.8.3,210.5-209.5c4.5-6.1-2.6-12.5-9-12.1l-413.8.2ZM472,151l-187.7,185.8c-18.6,12.2-43.2,11-60.3-3.3L40,150v270.5c0,3.2,6.6,9.5,10.5,8.5h411.1c3.2.9,10.5-3.6,10.5-6.5V151Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.795f3b6cd00f442942bbb094d6e8a117.svg";
export { ForwardRef as ReactComponent };